<template>
  <div>
      <!--<canvas style="width: 100%;" ref="pdfCanvas"></canvas>-->
      <canvas v-for="page in pages" :id="tabIndex + subIndex + 'the-canvas'+page" :key="tabIndex + subIndex + page"  style="width: 100%;"></canvas>
  </div>
</template>

<script>
    import * as pdfjsLib from 'pdfjs-dist';
    import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
    
    pdfjsLib.pdfjsWorker = pdfjsWorker;
    
    export default {
        name: '',
        data () {
            return {
              pdfDoc:null,
              pages: 0,
            }
        },
        props:{
          pdfUrl: {
            type: String,
            default: ''
          },
          tabIndex: {
            type: [String, Number],
            default: '0'
          },
          subIndex: {
            type: [String, Number],
            default: '0'
          }
        },
        methods:{
            async loadPagePdf(num) {
                const page = await this.pdfDoc.getPage(num);
                const viewport = page.getViewport({ scale: 1.5 });
                const canvas = document.getElementById(this.tabIndex + this.subIndex + 'the-canvas' + num)
                const context = canvas.getContext('2d');
                canvas.height = viewport.height; 
                canvas.width = viewport.width;
                const renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                page.render(renderContext);
                if (num < this.pages) {
                  this.loadPagePdf(num + 1);
                }
            },
            async loadPdf() {
                const loadingTask = pdfjsLib.getDocument(this.pdfUrl);
                this.pdfDoc = await loadingTask.promise;
                console.log('pdf内容页数..:', this.pdfDoc.numPages)
                this.pages = this.pdfDoc.numPages
//              for(let index = 0; index < this.pages; index++ ) {
//                  this.loadPagePdf(index + 1)
//              }
                this.loadPagePdf(1)
            },
      },
        created(){
        },
        mounted(){
            this.loadPdf();
        }
    }
</script>


<style>
  .return{
    position: absolute;left:30px;
    font-size:50px;
    font-weight: 600;
    top:-3px;
  }
  .title2{
    width: 70%;
    display: inline-block;
    text-align: center;
    white-space:nowrap;
    overflow: hidden;
  }
  .navigationBar{
    height: 100px;
    width: 100%;
    text-align: center;
    background-color: white;
    color: #1f2230;
    line-height:100px;
    font-size: 30px;
    position:fixed;
    top:0;
    z-index: 999;
  }
  .collection .no-collection{
    margin: 0 auto;
    margin-top: 60px;
    height: 550px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pdfbox.vue